$(document).ready(function(){
  /* Section  CM Product Slider */

       $('.cm-product_slider-row').slick({
       slidesToShow: 4,
       slidesToScroll: 1,
       dots: false,
       arrows: true,
             infinite: true,
     responsive: [
        
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }

  ]
     });
  
  /* Section  CM Card Slider 1 */
         $('.cm-card_slider_1-row').slick({
       slidesToShow:3,
        variableWidth: true,
       slidesToScroll: 1,
       dots: false,
       arrows: true,
             infinite: true,
     responsive: [
        
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }

  ]
     });
  
  /* Section  CM Card Slider 2 */

   $('.cm-card_slider_2-row').slick({
       slidesToShow:3,
       slidesToScroll: 1,
       dots: false,
       arrows: true,
             infinite: true,
         //  centerMode: true,
//centerPadding: '20%',
     responsive: [
        
        {
            breakpoint: 992 ,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1
            }
        }

  ]
     });
  
   });
